import { render, staticRenderFns } from "./PurchasingForm.vue?vue&type=template&id=389df8a4"
import script from "./PurchasingForm.vue?vue&type=script&lang=js"
export * from "./PurchasingForm.vue?vue&type=script&lang=js"
import style0 from "./PurchasingForm.vue?vue&type=style&index=0&id=389df8a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports